module.exports = __webpack_public_path__ + "static/apple-PLmag2-0c1d41efdc8b33c59a6b4dc5dd00d9cc.jpg";